/* eslint-disable react/prop-types */
import { useState } from "react";
import {
  ArrowDownSVG,
  ArrowLeftSVG,
  ArrowRightSVG,
  ArrowSVG,
  CalenderSVG,
  SearchSVG,
} from "../SvgImage/SvgImage";

const CustomDatePicker = ({
  setSelectdays,
  selectDays,
  today,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  handleSearch,
}) => {
  const monthdata = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const weekName = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

  const [openDate, setOpenDate] = useState(false);

  const [currentMonth, setCurrentMonth] = useState(today.getMonth());
  const [currentYear, setCurrentYear] = useState(today.getFullYear());
  const [pickerMode, setPickerMode] = useState(null);
  const [yearRangeStart, setYearRangeStart] = useState(
    today.getFullYear() - 10,
  );

  const getDaysInMonth = (year, month) =>
    new Date(year, month + 1, 0).getDate();
  const getStartDayOfMonth = (year, month) => new Date(year, month, 1).getDay();

  const goToPreviousMonth = () => {
    if (pickerMode === "month") {
      if (currentMonth === 0) {
        setCurrentMonth(11);
        setCurrentYear((prev) => prev - 1);
      } else {
        setCurrentMonth((prev) => prev - 1);
      }
    } else if (pickerMode === "year") {
      setYearRangeStart((prev) => prev - 21);
    } else {
      if (currentMonth === 0) {
        setCurrentMonth(11);
        setCurrentYear((prev) => prev - 1);
      } else {
        setCurrentMonth((prev) => prev - 1);
      }
    }
  };

  const goToNextMonth = () => {
    if (pickerMode === "month") {
      if (currentMonth === 11) {
        setCurrentMonth(0);
        setCurrentYear((prev) => prev + 1);
      } else {
        setCurrentMonth((prev) => prev + 1);
      }
    } else if (pickerMode === "year") {
      setYearRangeStart((prev) => prev + 21);
    } else {
      if (currentMonth === 11) {
        setCurrentMonth(0);
        setCurrentYear((prev) => prev + 1);
      } else {
        setCurrentMonth((prev) => prev + 1);
      }
    }
  };

  const generateCalendarDays = () => {
    const daysInMonth = getDaysInMonth(currentYear, currentMonth);
    const firstDay = getStartDayOfMonth(currentYear, currentMonth);
    const offset = (firstDay + 6) % 7;
    const days = [];

    for (let i = 0; i < offset; i++) days.push(null);
    for (let i = 1; i <= daysInMonth; i++) {
      days.push(new Date(currentYear, currentMonth, i));
    }
    return days;
  };

  const isDateInRange = (date) => {
    return (
      startDate &&
      endDate &&
      date >= new Date(startDate.setHours(0, 0, 0, 0)) &&
      date <= new Date(endDate.setHours(0, 0, 0, 0))
    );
  };

  const selectDate = (date) => {
    if (!startDate || (startDate && endDate)) {
      setStartDate(date);
      setEndDate(null);
    } else if (date < startDate) {
      setStartDate(date);
    } else {
      setEndDate(date);
      setOpenDate(false);
    }
  };

  const formatDate = (date) =>
    date
      ? date.toLocaleDateString("en-US", {
          month: "long",
          day: "numeric",
          year: "numeric",
        })
      : "";

  const calendarDays = generateCalendarDays();
  const yearList = Array.from({ length: 21 }, (_, i) => yearRangeStart + i);

  return (
    <div className="border-t  border-border_color_primary mt-2 lg:border-none">
      <div className="relative w-full">
        <div className="w-full flex flex-col gap-2 bg-bg_Quaternary py-2">
          <div className="flex items-center gap-2 w-full px-2">
            <div className="flex flex-1 items-center gap-2 px-2 py-1  border border-border_color_primary rounded-lg cursor-pointer shadow-sm  transition-colors min-h-[34px] duration-200 ease-in-out text-xs sm:text-sm">
              <div className="flex-1 min-w-0 pr-4">
                <div
                  className="flex items-center gap-2 justify-between w-full"
                  onClick={() => setOpenDate(!openDate)}
                >
                  <span className="text-text_color_primary1">
                    {formatDate(startDate)}
                  </span>
                  <ArrowSVG />
                  <span className="text-text_color_primary1">
                    {formatDate(endDate)}
                  </span>
                </div>
              </div>
              <CalenderSVG />
            </div>
            <button
              className="relative overflow-hidden w-max h-full min-w-[34px] min-h-[34px] aspect-square flex items-center justify-center border border-border_color_primary rounded-lg cursor-pointer bg-bg_text_brand_primary shadow-sm hover:bg-bg_color_input_bg transition-colors duration-200 ease-in-out"
              type="button"
              onClick={handleSearch}
            >
              <SearchSVG />
            </button>
          </div>
          <div className="flex items-center gap-2 w-full justify-center">
            {[
              { label: "Last 7 days", days: 7 },
              { label: "Last 14 days", days: 13 },
              { label: "Last 28 days", days: 27 },
            ].map(({ label, days }) => (
              <div
                key={label}
                onClick={() => {
                  const start = new Date();
                  start.setDate(start.getDate() - days);
                  setStartDate(start);
                  setEndDate(new Date());
                  setSelectdays(days);
                }}
                className={`flex items-center gap-2 px-2.5 py-1.5 border border-border_color_primary rounded-lg cursor-pointer shadow-sm transition-colors duration-200 ease-in-out text-xs sm:text-sm ${
                  days === selectDays
                    ? "bg-bg_text_brand_primary text-text_color_primary2"
                    : "bg-bg_color_primary hover:bg-bg_color_input_bg text-text_color_primary1"
                }`}
              >
                {label}
              </div>
            ))}
          </div>
        </div>

        {openDate && (
          <div className="absolute z-10 mt-2 transform transition-all duration-200 ease-in-out origin-top w-[94%] max-w-sm left-1/2 -translate-x-1/2">
            <div className="w-full max-w-md md:max-w-lg bg-bg_color_primary rounded-lg shadow-passwordRulesBox overflow-hidden border border-border_color_primary">
              <div className="px-2 sm:px-4 pt-4 pb-2">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <button
                      className="relative overflow-hidden text-sm md:text-base font-semibold border border-border_color_primary px-2 py-1 rounded-md text-text_color_primary1 flex items-center"
                      onClick={() =>
                        setPickerMode((prev) =>
                          prev === "month" ? null : "month",
                        )
                      }
                    >
                      {monthdata[currentMonth]}
                      <ArrowDownSVG pickerMode={pickerMode} year={"month"} />
                    </button>
                    <button
                      className="relative overflow-hidden text-sm md:text-base font-semibold border border-border_color_primary px-2 py-1 rounded-md text-text_color_primary1 flex items-center"
                      onClick={() =>
                        setPickerMode((prev) =>
                          prev === "year" ? null : "year",
                        )
                      }
                    >
                      {currentYear}
                      <ArrowDownSVG pickerMode={pickerMode} year="year" />
                    </button>
                  </div>
                  <div className="flex items-center space-x-2">
                    <button onClick={goToPreviousMonth} type="button">
                      <ArrowLeftSVG />
                    </button>
                    <button onClick={goToNextMonth} type="button">
                      <ArrowRightSVG />
                    </button>
                  </div>
                </div>
              </div>

              {pickerMode === "month" ? (
                <div className="grid grid-cols-3 gap-2 p-4 border-b">
                  {monthdata.map((month, id) => (
                    <button
                      key={id}
                      className={`relative overflow-hidden p-2 text-sm rounded-md transition-colors duration-200 ${
                        monthdata[currentMonth] === month
                          ? "bg-bg_text_brand_primary"
                          : ""
                      } hover:bg-bg_color_quaternary text-text_color_primary1`}
                      onClick={() => {
                        setCurrentMonth(id);
                        setPickerMode(null);
                      }}
                    >
                      {month}
                    </button>
                  ))}
                </div>
              ) : pickerMode === "year" ? (
                <div className="grid grid-cols-3 gap-2 p-4 max-h-60 overflow-y-auto border-b">
                  {yearList.map((year) => (
                    <button
                      key={year}
                      className={`relative overflow-hidden p-2 text-sm rounded-md transition-colors duration-200 ${
                        year === currentYear
                          ? "bg-bg_text_brand_primary text-white"
                          : "hover:bg-bg_color_quaternary text-text_color_primary1"
                      }`}
                      onClick={() => {
                        setCurrentYear(year);
                        setPickerMode(null);
                      }}
                    >
                      {year}
                    </button>
                  ))}
                </div>
              ) : (
                ""
              )}

              <div className="p-4">
                <div className="grid grid-cols-7 gap-1 mb-2">
                  {weekName.map((week, index) => (
                    <div
                      key={index}
                      className="h-8 flex text-text_color_primary1 items-center justify-center text-xs font-medium "
                    >
                      {week}
                    </div>
                  ))}
                </div>
                <div className="grid grid-cols-7 gap-1">
                  {calendarDays.map((date, idx) =>
                    date ? (
                      <div
                        key={idx}
                        onClick={() => selectDate(date)}
                        className={`h-8 md:h-10 aspect-square flex items-center justify-center text-sm rounded-full cursor-pointer transition-all duration-200 ${
                          isDateInRange(date)
                            ? "bg-bg_color_quaternary text-text_color_primary1 font-semibold"
                            : "hover:bg-bg_color_quaternary text-text_color_primary1"
                        }`}
                      >
                        {date.getDate()}
                      </div>
                    ) : (
                      <div key={idx} className="h-8 md:h-10" />
                    ),
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomDatePicker;
